"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var downshift_1 = require("downshift");
var Portal_1 = __importDefault(require("../portal/Portal"));
var Select_styled_1 = require("./Select.styled");
var components_1 = require("../../styles/components");
var utils_1 = require("../../utils");
var Input_styled_1 = require("../input/Input.styled");
function Select(_a) {
    var _b = _a.disabled, disabled = _b === void 0 ? false : _b, placeholder = _a.placeholder, label = _a.label, name = _a.name, onChange = _a.onChange, options = _a.options, value = _a.value, className = _a.className, required = _a.required, dropdownStyle = _a.dropdownStyle;
    var itemToString = function (item) {
        return item ? item.label : '';
    };
    var _c = downshift_1.useSelect({
        items: options,
        itemToString: itemToString,
        selectedItem: value,
        onSelectedItemChange: function (_a) {
            var selectedItem = _a.selectedItem;
            return onChange(selectedItem, name);
        },
    }), isOpen = _c.isOpen, getToggleButtonProps = _c.getToggleButtonProps, getLabelProps = _c.getLabelProps, getMenuProps = _c.getMenuProps, highlightedIndex = _c.highlightedIndex, getItemProps = _c.getItemProps;
    var _d = utils_1.useScrollAnchor(isOpen), anchorRef = _d[0], listRef = _d[1];
    react_1.useEffect(function () {
        utils_1.setListMenuDomRect(isOpen, listRef, anchorRef);
    }, [anchorRef, isOpen, listRef]);
    return (react_1.default.createElement(Select_styled_1.StyledSelectWrapper, { className: className },
        label ? (react_1.default.createElement(components_1.InputLabel, __assign({}, getLabelProps({ htmlFor: name, required: required })), label)) : null,
        react_1.default.createElement(Input_styled_1.StyledInput, __assign({}, getToggleButtonProps({
            disabled: disabled,
            id: name,
            ref: anchorRef,
        }), { as: "button" }),
            react_1.default.createElement(Select_styled_1.SelectText, null, value ? (react_1.default.createElement("div", null, itemToString(value))) : (react_1.default.createElement(components_1.PlaceholderText, null, placeholder))),
            disabled ? null : (react_1.default.createElement(Select_styled_1.StyledSelectArrow, null,
                react_1.default.createElement("div", null)))),
        react_1.default.createElement(Portal_1.default, null,
            react_1.default.createElement(components_1.StyledList, __assign({ style: dropdownStyle }, getMenuProps({ ref: listRef })), isOpen &&
                options.map(function (item, index) { return (react_1.default.createElement(components_1.StyledListItem, __assign({}, getItemProps({
                    item: item,
                    index: index,
                }), { key: index, isActive: highlightedIndex === index }), item.label)); })))));
}
exports.default = Select;
//# sourceMappingURL=Select.js.map